import type { IconSvgObject } from './types';

const FolderShared03Icon: IconSvgObject = [
  ["path", { d: "M12.0064 18V21.9846M20.5 22H3.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 5.5H12.0179M12.0179 5.5H20C21.1046 5.5 22 6.39543 22 7.5V16C22 17.1046 21.1046 18 20 18H4C2.89543 18 2 17.1046 2 16V3C2 2.44772 2.44772 2 3 2H8.54185C8.83274 2 9.10922 2.12667 9.29918 2.34698L12.0179 5.5Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }]
];

export default FolderShared03Icon;
